var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"vs-nav-item"},[_c('div',{staticClass:"vs-nav-item-slot"},[_vm._t("default")],2),_c('ul',{staticClass:"vs-nav-submenu"},[_vm._t("submenu")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }